import React from 'react'

function AdminsPage() {
  return (
    <div>AdminsPage</div>
  )
}

export default AdminsPage